export const formatDate = date => {
  const dt = new Date(date);
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  const hh = String(dt.getHours()).padStart(2, "0");
  const ii = String(dt.getMinutes()).padStart(2, "0");
  const ss = String(dt.getSeconds()).padStart(2, "0");

  return `${dd}/${mm}/${yyyy} ${hh}:${ii}:${ss}`;
};

export const baseDate = dt => {
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  const hh = String(dt.getHours()).padStart(2, "0");
  const ii = String(dt.getMinutes()).padStart(2, "0");
  const ss = String(dt.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd} ${hh}:${ii}:${ss}`;
};

export const friendlyDate = date => {
  const dt = new Date(date);
  const hj = new Date();
  const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];

  if (dt.getFullYear() !== hj.getFullYear()) {
    return `${dt.getDate()} de ${months[dt.getMonth()]} de ${dt.getFullYear()}`;
  }

  return `${dt.getDate()} de ${
    months[dt.getMonth()]
  }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(-2)}`;
};

export const remainingTime = date => {
  const dt = new Date(date);
  const hj = new Date();

  const days = (dt - hj) / (1000 * 60 * 60 * 24);

  if (days >= 1) {
    return `${Math.floor(days)} dias restando`;
  }
  if (days < 0) {
    return "Encerrado";
  }
  const hours = (days * 24) % 24;
  const minutes = (hours * 60) % 60;

  if (hours >= 1) {
    return `${Math.floor(hours)}h${`00${Math.floor(minutes)}`.slice(
      -2
    )}min restando`;
  }
  if (minutes >= 1) {
    return `${Math.floor(minutes)}min restando`;
  }
  return "Encerrando agora";
};

export const interval = (start, end) => {
  const dt = new Date(end);
  const hj = new Date(start);

  const days = (dt - hj) / (1000 * 60 * 60 * 24);

  if (days >= 1) {
    return `${Math.floor(days)} dias`;
  }
  const hours = (days * 24) % 24;
  const minutes = (hours * 60) % 60;
  const seconds = (minutes * 60) % 60;

  if (hours >= 1) {
    return `${Math.floor(hours)}h${`00${Math.floor(minutes)}`.slice(-2)}min`;
  }
  if (minutes >= 1) {
    return `${Math.floor(minutes)} minutos`;
  }
  return `${Math.floor(seconds)} segundos`;
};

export const isToday = (someDate, day) => {
  const today = day || new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

export const baseToDateTimeLocal = dt => {
  const date = new Date(dt);
  let tzo = -date.getTimezoneOffset();
  let dif = tzo >= 0 ? "+" : "-";
  let pad = num => (num < 10 ? "0" : "") + num;

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
